/**
 * 秒数を "m:ss" 形式の文字列に変換する
 * @param seconds - 変換する秒数
 * @returns "m:ss" 形式の文字列
 */
const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${String(mins)}:${secs.toString().padStart(2, '0')}`;
};

export default formatTime;
